import React, { memo } from "react";

import { OperatorPanel } from "Components/OperatorSidePanel/OperatorPanel";
import { StationInspection } from "./components/StationInspection";

import { StationWrapperStyled } from "./styles";

export const Stations = memo(() => {
  return (
    <StationWrapperStyled>
      <OperatorPanel />
      <StationInspection />
    </StationWrapperStyled>
  );
});
